import FaqItem from "./FaqItem";

import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/your-stay-banner.webp";
import hotelImg from "./imgs/hotel.png";

const YourStay = ({ onClose, hotelInfo, hotelOptions, eventName }) => {
  // const parseHotelAddress = (address) => {
  //   return address.split("\n").map((line, i) => <p key={i}>{line}</p>);
  // };

  const FAQS = [
    {
      category: "Accommodation",
      questions: [
        {
          question: "What costs are included in my accommodation?",
          answer: "Room, applicable taxes (VAT), breakfast, Wi-Fi."
        },
        {
          question: "What transportation is included in the program?",
          answer:
            "Transportation to/from arrival point, as well as to/from all organized activities."
        },
        {
          question: "How do I get around on site?",
          answer: "Mastercard will organise all your transport."
        }
      ]
    },
    {
      category: "Arrival",
      questions: [
        {
          question: "What is the check-in and check-out time?",
          answer: "Check-in: 15:00\nCheck-out: 11:00"
        },
        {
          question:
            "Will I be responsible for covering the hotel costs during my stay in Cannes?",
          answer:
            "You cover all additional costs (minibar, phone, bar bills, in-room services, laundry, etc.).\nHotel requires a Mastercard credit card for incidentals."
        }
      ]
    },
    {
      category: "Emergency services numbers",
      questions: [
        {
          question:
            "What is the phone number of the emergency service in Cannes?",
          answer: "Police, Fire, Medical: 112"
        }
      ]
    },
    {
      category: "Exclusive Activities",
      questions: [
        {
          question: "What is the currency in Cannes?",
          answer: "Euro (€), credit and debit cards widely accepted."
        },

        {
          question: "What is the weather like in Cannes in May?",
          answer: "Average high: 20°C / 68°F\nAverage low: 15°C / 59°F"
        },
        {
          question: "What is the dress code for the business session?",
          answer: "Smart casual"
        },

        {
          question: "Who do I contact on-site with event questions?",
          answer: "Please go to the Mastercard Welcome Desk"
        }
      ]
    },
    {
      category: "Local Cuisine",
      questions: [
        {
          question: "What restaurants are included in the program?",
          answer:
            "The lunch and dinner menus of our exclusive locations have been meticulously crafted and personalised by our team in collaboration with the chefs to enchant your taste buds."
        }
      ]
    },
    {
      category: "The Red Carpet",
      hideForF1: true,
      questions: [
        {
          question: "What is the dress code for the Red Carpet?",
          answer:
            "The legendary Red Carpet event is a high-profile, media-covered occasion that comes with its very own etiquette.\n To celebrate the work of art of the artists and film crews, attendees are kindly asked to dress appropriately for the gala event.\n Men are required to wear a black tuxedo, white shirt, black bow tie, black tuxedo belt, black shoes and black socks.\n Women may wear an evening dress, a cocktail dress dark-coloured suit, a dressy top with black trousers, a black dress, a black or midnight blue suit with bow tie.\n Elegant shoes with or without heels are required. Trainers are not permitted."
        }
      ]
    },
    {
      category: "Nice to know",
      hideForF1: true,
      questions: [
        {
          question: "78th CANNES FILM FESTIVAL 2025",
          answer:
            "Every year, for 12 days in May, this small town on France’s glitzy Côte d’Azur becomes the center of the cinematic universe, with more than 30.000 producers, distributors, directors, publicists, stars and hangers- on coming to buy, sell or promote more than 2000 films.\n As the premier film event of the year, the festival attracts around 4.000 journalists from around the world, ensuring a global spotlight on anyone with enough charisma or prestige to seize it.\n Ever since its creation, the Festival de Cannes has remained faithful to its founding purpose: to draw attention to and raise the profile of films with the aim of contributing towards to the development of cinema, boosting the film industry worldwide and celebrating cinema at an international level."
        }
      ]
    }
  ];

  const hotelDetails = hotelInfo?.options?.find(
    (item) => item?.id === hotelOptions?.selectedOptionId
  );

  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Your Stay"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            {eventName === "CANNES" ? (
              <p>
                {
                  "Find all information about the Cannes Film Festival and your stay with Mastercard."
                }
              </p>
            ) : (
              <p>
                {
                  "Find all information about the Monaco Grand Prix and your stay with Mastercard."
                }
              </p>
            )}
            <p className="bold">{"Accommodation"}</p>
          </div>

          <div className="section bg-black hotel-section">
            <img src={hotelImg} alt="hotel" />
            <div className="hotel-info">
              <p className="bold">{hotelDetails?.item}</p>
              <p>Le Majestic</p>
              <p>10 Boulevard de La Croisette</p>
              <p>06400 Cannes</p>
            </div>
          </div>

          <div className="section">
            <p className="bold">{"FAQs"}</p>
            <div className="faq-container">
              {FAQS.map((faq, index) => (
                <FaqItem
                  eventName={eventName}
                  key={index}
                  {...faq}
                  isLast={index === FAQS.length - 1}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default YourStay;
